import React from 'react'

interface UnionDownProps {
  color?: string
}

const UnionDown = ({ color = '#649bf3' }: UnionDownProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
    >
      <path
        d="M3.98981 9.80263C4.22554 10.0658 4.6634 10.0658 4.89914 9.80263L8.7531 5.50037C9.07015 5.14643 8.79672 4.61245 8.29843 4.61245L6.21256 4.61245L6.21256 0.54264C6.21256 0.242948 5.94869 -2.57043e-07 5.6232 -2.85498e-07L3.26575 -4.91593e-07C2.94025 -5.20049e-07 2.67639 0.242948 2.67639 0.54264L2.67639 4.61245L0.59051 4.61245C0.0922236 4.61245 -0.181207 5.14643 0.135845 5.50037L3.98981 9.80263Z"
        fill={color}
      />
    </svg>
  )
}

export default UnionDown
